/** Config for the AuthClient */
export interface AuthClientConfig {
  /** The client id of the application. */
  clientID: string;

  /** The auth audience to use. */
  audience: string;
}

export const getAuthClientConfig = (hostname: string) => {
  const onProd = hostname === 'app.viam.com';

  return {
    clientId: onProd
      ? import.meta.env.VITE_FUSIONAUTH_PROD_CLIENT_ID
      : import.meta.env.VITE_FUSIONAUTH_STAGING_CLIENT_ID,
    audience: onProd
      ? import.meta.env.VITE_FUSIONAUTH_PROD_AUDIENCE
      : import.meta.env.VITE_FUSIONAUTH_STAGING_AUDIENCE,
  };
};
